var _circle, _mask, _g, _path, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 4,
    fill: "#464646"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 8,
    height: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#464646"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7028 4.14715C23.9807 8.34335 24.1129 15.1917 20 19.5498C19.4693 20.0993 18.8828 20.5919 18.25 21.0198C17.9633 21.2265 17.6667 21.4165 17.36 21.5898C17.07 21.7498 16.77 21.8998 16.47 22.0398L16.36 22.0898C16.08 22.2098 15.78 22.3198 15.49 22.4198L15.31 22.4898C15.0645 22.5717 14.8024 22.637 14.5464 22.7008C14.5208 22.7071 14.4954 22.7135 14.47 22.7198L14.22 22.7798C14.1653 22.7916 14.1105 22.8041 14.0557 22.8166C13.8301 22.8681 13.6033 22.9198 13.37 22.9198H13.1C12.3355 23.0007 11.5645 23.0007 10.8 22.9198H10.53C10.24 22.8798 9.96001 22.8398 9.68001 22.7798L9.43001 22.7198C9.40463 22.7135 9.37917 22.7071 9.35365 22.7008C9.09761 22.637 8.83554 22.5717 8.59001 22.4898L8.41001 22.4198C8.11001 22.3198 7.82001 22.2098 7.54001 22.0898L7.43001 22.0398C7.13001 21.8998 6.83001 21.7498 6.54001 21.5898C6.23335 21.4165 5.93668 21.2265 5.65001 21.0198C5.05206 20.5865 4.49927 20.094 4.00001 19.5498C-0.112871 15.1917 0.019281 8.34335 4.29724 4.14715C8.57519 -0.0490501 15.4248 -0.0490501 19.7028 4.14715ZM20.5498 7.90273C18.9626 4.62611 15.6408 2.54637 12 2.54983V2.51983C8.35923 2.51637 5.0374 4.59611 3.45022 7.87273C1.86304 11.1493 2.29034 15.0451 4.55001 17.8998C5.71001 16.2198 8.60001 15.0198 12 15.0198C15.4 15.0198 18.29 16.2198 19.45 17.9298C21.7097 15.0751 22.137 11.1793 20.5498 7.90273Z",
    fill: "#464646"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7028 4.14715C23.9807 8.34335 24.1129 15.1917 20 19.5498C19.4693 20.0993 18.8828 20.5919 18.25 21.0198C17.9633 21.2265 17.6667 21.4165 17.36 21.5898C17.07 21.7498 16.77 21.8998 16.47 22.0398L16.36 22.0898C16.08 22.2098 15.78 22.3198 15.49 22.4198L15.31 22.4898C15.0645 22.5717 14.8024 22.637 14.5464 22.7008C14.5208 22.7071 14.4954 22.7135 14.47 22.7198L14.22 22.7798C14.1653 22.7916 14.1105 22.8041 14.0557 22.8166C13.8301 22.8681 13.6033 22.9198 13.37 22.9198H13.1C12.3355 23.0007 11.5645 23.0007 10.8 22.9198H10.53C10.24 22.8798 9.96001 22.8398 9.68001 22.7798L9.43001 22.7198C9.40463 22.7135 9.37917 22.7071 9.35365 22.7008C9.09761 22.637 8.83554 22.5717 8.59001 22.4898L8.41001 22.4198C8.11001 22.3198 7.82001 22.2098 7.54001 22.0898L7.43001 22.0398C7.13001 21.8998 6.83001 21.7498 6.54001 21.5898C6.23335 21.4165 5.93668 21.2265 5.65001 21.0198C5.05206 20.5865 4.49927 20.094 4.00001 19.5498C-0.112871 15.1917 0.019281 8.34335 4.29724 4.14715C8.57519 -0.0490501 15.4248 -0.0490501 19.7028 4.14715ZM20.5498 7.90273C18.9626 4.62611 15.6408 2.54637 12 2.54983V2.51983C8.35923 2.51637 5.0374 4.59611 3.45022 7.87273C1.86304 11.1493 2.29034 15.0451 4.55001 17.8998C5.71001 16.2198 8.60001 15.0198 12 15.0198C15.4 15.0198 18.29 16.2198 19.45 17.9298C21.7097 15.0751 22.137 11.1793 20.5498 7.90273Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1afed6d2e8ebdc00786921fcb89af6c8.svg";
export { ForwardRef as ReactComponent };